module.exports = __webpack_public_path__ + "img/lr11ll1y1.891cbc0a.gif";